// -> compact JSON for page_context.hazard (strings trimmed by buildBiqPageContext). The affected regions are not
// computed yet, so `exposure` says 'off': a missing answer is never read as "nothing exposed".
export function hazardBiqSummary({ event, classWords, status }) {
  if (!event) return null;
  return {
    name: event.name,
    type: event.type,
    class: classWords || null,
    location: event.location || null,
    updated: event.dateModified ? `${event.dateModified}Z`.replace(/Z+$/, 'Z') : null,     // source ISO has no zone
    status: event.isCurrent ? 'current' : 'ended',
    path: status,                                                                            // idle|unavailable|loading|error|ready
    exposure: 'off',
  };
}
